import { filtersTypeById } from "../../../Components/Filters/filtersTypeById"

// Filter chips for Admin Disputes (/admin/disputes): the merchant list's chips plus the admin
// block — the account, its owner, its site and our fee. Option lists are passed in by the page,
// so nothing here duplicates the dispute vocabularies.
export const ADMIN_FILTER_TYPES = {
  ...filtersTypeById,
  status: {
    id: "status",
    label: "Status",
    allBtnText: "All statuses",
    type: "checkbox",
    sortDisabled: true
  },
  dispute_type: {
    id: "dispute_type",
    label: "Type",
    allBtnText: "All types",
    type: "checkbox",
    sortDisabled: true
  },
  submission: {
    id: "submission",
    label: "Submission",
    allBtnText: "All events",
    type: "checkbox",
    sortDisabled: true
  },
  flag_reason: {
    id: "flag_reason",
    label: "Flag",
    allBtnText: "All flags",
    type: "checkbox",
    sortDisabled: true
  },
  reason_category: {
    id: "reason_category",
    label: "Category",
    allBtnText: "All categories",
    type: "checkbox"
  },
  reason_code: {
    id: "reason_code",
    label: "Reason code",
    allBtnText: "All codes",
    type: "checkbox",
    withSearch: true
  },
  issuer: {
    id: "issuer",
    label: "Card network",
    allBtnText: "All networks",
    type: "checkbox"
  },
  issuing_bank: {
    id: "issuing_bank",
    label: "Issuer",
    allBtnText: "All issuers",
    type: "checkbox",
    withSearch: true
  },
  card_type: {
    id: "card_type",
    label: "Card type",
    allBtnText: "All card types",
    type: "checkbox"
  },
  currency: {
    id: "currency",
    label: "Currency",
    allBtnText: "All currencies",
    type: "checkbox"
  },
  // `country` is already taken by the shared country list in filterOptionsData, which
  // would override the page's own options, so the chip has its own key. The query
  // builder still sends it as `country`.
  card_country: {
    id: "card_country",
    label: "Country",
    allBtnText: "All countries",
    type: "checkbox",
    withSearch: true
  },
  processor: {
    id: "processor",
    label: "Payment processor",
    allBtnText: "All processors",
    type: "checkbox"
  },
  assignee: {
    id: "assignee",
    label: "Assignee",
    allBtnText: "All assignees",
    type: "checkbox"
  },
  paid_status: {
    id: "paid_status",
    label: "Paid status",
    allBtnText: "All",
    type: "checkbox",
    sortDisabled: true
  },
  customer: {
    id: "customer",
    label: "Customer full name",
    title: "Customer full name",
    searchPlaceholder: "Separate by comma",
    type: "tags"
  },
  card_last4: {
    id: "card_last4",
    label: "Card last 4",
    title: "Card last 4",
    searchPlaceholder: "Separate by comma",
    type: "tags"
  },
  processor_dispute_id: {
    id: "processor_dispute_id",
    label: "Dispute ID",
    title: "Dispute ID",
    searchPlaceholder: "Separate by comma",
    type: "tags"
  },
  business_url: {
    id: "business_url",
    label: "Business URL",
    title: "Business URL",
    searchPlaceholder: "Separate by comma",
    type: "tags"
  },
  amount: {
    id: "amount",
    label: "Amount",
    title: "Filter by amount",
    type: "number",
    min: 0
  },
  enrichment: {
    id: "enrichment",
    label: "Enrichment",
    title: "Filter by enrichment",
    type: "whole_number",
    min: 0
  },
  date: {
    id: "date",
    label: "Dispute date",
    type: "date"
  },
  updated: {
    id: "updated",
    label: "Last update",
    type: "date"
  }
}
